import React, { createContext, PropsWithChildren, useContext } from 'react';
import { OpenPanelType } from '../ProductionDataGrid';

type DataListCellContextValue = {
    isNotesPanelOpen: boolean;
    openPanelType: OpenPanelType;
};

const DataListCellContext = createContext<DataListCellContextValue | undefined>(undefined);

export function useDataListCell() {
    const context = useContext(DataListCellContext);

    if (context === undefined) {
        throw new Error('useDataListCell must be used within a DataListCellProvider');
    }

    return context;
}

type DataListCellProviderProps = PropsWithChildren<{
    isNotesPanelOpen: boolean;
    openPanelType: OpenPanelType;
}>;

export const DataListCellProvider = React.memo(
    ({ isNotesPanelOpen, openPanelType, children }: DataListCellProviderProps) => {
        const value = { isNotesPanelOpen, openPanelType };

        return <DataListCellContext.Provider value={value}>{children}</DataListCellContext.Provider>;
    }
);
